// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"Fieldset_fieldset__1Eo3v","large":"Fieldset_large__1veU6"};